/** @returns {{ currency: 'irt' | 'usd', livePrice: false }} */
function getCurrencyChartPresentation(currency = 'irt') {
  return {
    currency: currency === 'usd' ? 'usd' : 'irt',
    livePrice: false,
  };
}

module.exports = { getCurrencyChartPresentation };
